import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

export const AccountSettingChangePasswordIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M24 16.6663H25.6667C26.1269 16.6663 26.5 17.0394 26.5 17.4997V27.4997C26.5 27.9599 26.1269 28.333 25.6667 28.333H12.3333C11.8731 28.333 11.5 27.9599 11.5 27.4997V17.4997C11.5 17.0394 11.8731 16.6663 12.3333 16.6663H14V15.833C14 13.0716 16.2386 10.833 19 10.833C21.7614 10.833 24 13.0716 24 15.833V16.6663ZM13.1667 18.333V26.6663H24.8333V18.333H13.1667ZM18.1667 21.6663H19.8333V23.333H18.1667V21.6663ZM14.8333 21.6663H16.5V23.333H14.8333V21.6663ZM21.5 21.6663H23.1667V23.333H21.5V21.6663ZM22.3333 16.6663V15.833C22.3333 13.9921 20.8409 12.4997 19 12.4997C17.159 12.4997 15.6667 13.9921 15.6667 15.833V16.6663H22.3333Z"
      fill="#181818"
    />
  </svg>
);

export const AccountSettingLanguageIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M14.1959 15.3781C13.0425 16.5766 12.3333 18.2056 12.3333 20.0003C12.3333 23.6822 15.3181 26.667 19 26.667C19.9007 26.667 20.7597 26.4884 21.5434 26.1647C21.6392 25.5392 21.429 24.9392 21.343 24.7292C21.1517 24.2628 20.5201 23.4655 19.4657 22.3593C19.1843 22.0635 19.2024 21.8366 19.303 21.1622L19.3146 21.0861C19.3829 20.6242 19.4976 20.3511 21.0518 20.1043C21.8414 19.9792 22.0491 20.2947 22.3369 20.7317C22.3687 20.7802 22.4006 20.8277 22.4332 20.8752C22.7066 21.2751 22.9092 21.3665 23.2152 21.5057C23.3522 21.5678 23.5233 21.6462 23.7526 21.7765C24.2959 22.087 24.2959 22.4376 24.2959 23.2063V23.2935C24.2959 23.6198 24.264 23.9063 24.2138 24.1552C25.1232 23.0157 25.6667 21.5715 25.6667 20.0003C25.6667 17.2511 24.0025 14.8905 21.6266 13.871C21.1656 14.1821 20.5332 14.623 20.3125 14.9253C20.1997 15.0798 20.0402 15.8684 19.5214 15.9335C19.3855 15.9505 19.2032 15.9386 19.01 15.9261C18.4921 15.8925 17.7835 15.847 17.5567 16.4628C17.4127 16.853 17.3873 17.9124 17.8532 18.4622C17.9278 18.5501 17.9422 18.7126 17.8916 18.8949C17.825 19.1343 17.6905 19.28 17.6486 19.3101C17.5682 19.2639 17.408 19.0779 17.2995 18.9513C17.0379 18.6474 16.7117 18.2689 16.29 18.1518C16.1366 18.1094 15.968 18.0742 15.8046 18.0398C15.347 17.9439 14.8287 17.8348 14.7083 17.5778C14.6203 17.3897 14.6207 17.1305 14.6211 16.8567C14.6211 16.5097 14.6211 16.1172 14.4511 15.7358C14.3854 15.5882 14.2974 15.4707 14.1959 15.3781ZM19 28.3337C14.3976 28.3337 10.6667 24.6027 10.6667 20.0003C10.6667 15.398 14.3976 11.667 19 11.667C23.6023 11.667 27.3333 15.398 27.3333 20.0003C27.3333 24.6027 23.6023 28.3337 19 28.3337Z"
      fill="#181818"
    />
  </svg>
);

export const AccountSettingThemeIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M19 28.3307C14.3976 28.3307 10.6667 24.5998 10.6667 19.9974C10.6667 15.395 14.3976 11.6641 19 11.6641C23.6023 11.6641 27.3333 15.395 27.3333 19.9974C27.3333 24.5998 23.6023 28.3307 19 28.3307ZM19 26.6641C22.6819 26.6641 25.6667 23.6793 25.6667 19.9974C25.6667 16.3155 22.6819 13.3307 19 13.3307C15.3181 13.3307 12.3333 16.3155 12.3333 19.9974C12.3333 23.6793 15.3181 26.6641 19 26.6641ZM14.8336 22.7635C16.5666 22.6373 18.2642 21.9117 19.5892 20.5866C20.9143 19.2616 21.6399 17.564 21.7661 15.831C22.0378 16.0119 22.2958 16.2222 22.5355 16.4619C24.4882 18.4145 24.4882 21.5803 22.5355 23.5329C20.5829 25.4856 17.4171 25.4856 15.4645 23.5329C15.2247 23.2932 15.0145 23.0352 14.8336 22.7635Z"
      fill="#181818"
    />
  </svg>
);

export const AccountSettingDeleteAccountIcon = (props: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H31C35.4183 0 39 3.58172 39 8V31C39 35.4183 35.4183 39 31 39H8C3.58172 39 0 35.4183 0 31V8Z"
      fill="white"
    />
    <path
      d="M15.6483 13.3024V11.6357H23.9817V13.3024H28.1483V14.9691H26.4817V27.4691C26.4817 27.9293 26.1086 28.3024 25.6483 28.3024H13.9817C13.5214 28.3024 13.1483 27.9293 13.1483 27.4691V14.9691H11.4817V13.3024H15.6483ZM14.815 14.9691V26.6357H24.815V14.9691H14.815ZM17.315 17.4691H18.9817V24.1357H17.315V17.4691ZM20.6483 17.4691H22.315V24.1357H20.6483V17.4691Z"
      fill="#181818"
    />
  </svg>
);
